import { render, staticRenderFns } from "./SizeAndWidth.vue?vue&type=template&id=1cf579e4&scoped=true&"
var script = {}
import style0 from "./SizeAndWidth.vue?vue&type=style&index=0&id=1cf579e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf579e4",
  null
  
)

export default component.exports